// extracted by mini-css-extract-plugin
module.exports =  {"reviews":"_33974c2b58--reviews--aXG7F"};